import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';
import './HomePage.css';

const HomePage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="home-container">
        <div className="welcome-section">
          <h1>Selamat Datang di Aplikasi Arisan</h1>
          <p>Solusi modern untuk mengelola grup arisan Anda</p>
          <div className="cta-buttons">
            <button onClick={() => navigate('/login')} className="btn-cta btn-login">
              Masuk
            </button>
            <button onClick={() => navigate('/register')} className="btn-cta btn-register">
              Daftar
            </button>
          </div>
        </div>

        <div className="features-section">
          <h2>Fitur</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>📋 Manajemen Grup</h3>
              <p>Buat dan kelola beberapa grup arisan dengan mudah</p>
            </div>
            <div className="feature-card">
              <h3>👥 Manajemen Anggota</h3>
              <p>Tambahkan anggota, lacak status, dan kelola partisipasi</p>
            </div>
            <div className="feature-card">
              <h3>💰 Pelacakan Transaksi</h3>
              <p>Catat iuran dan pembagian dengan riwayat lengkap</p>
            </div>
            <div className="feature-card">
              <h3>📊 Laporan & Statistik</h3>
              <p>Lihat ringkasan komprehensif aktivitas arisan Anda</p>
            </div>
            <div className="feature-card">
              <h3>🔒 Aman & Pribadi</h3>
              <p>Data Anda aman dengan autentikasi dan otorisasi</p>
            </div>
            <div className="feature-card">
              <h3>📱 Mudah Digunakan</h3>
              <p>Antarmuka intuitif untuk navigasi dan penggunaan mudah</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="dashboard-header">
        <h1>Selamat Datang, {user.name}!</h1>
        <p>Ini adalah dasbor arisan Anda</p>
      </div>

      <div className="dashboard-actions">
        <button onClick={() => navigate('/arisans')} className="action-card">
          <h3>Arisan Saya</h3>
          <p>Lihat semua grup arisan Anda</p>
        </button>
        <button onClick={() => navigate('/create-arisan')} className="action-card">
          <h3>Buat Arisan Baru</h3>
          <p>Mulai grup arisan baru</p>
        </button>
        <button onClick={() => navigate('/profile')} className="action-card">
          <h3>Profil Saya</h3>
          <p>Lihat dan ubah profil Anda</p>
        </button>
      </div>

      <div className="quick-info">
        <h2>Mulai Cepat</h2>
        <ol>
          <li>Buat grup arisan baru dengan mengatur jumlah iuran bulanan dan siklus</li>
          <li>Undang anggota untuk bergabung dengan grup arisan Anda</li>
          <li>Catat iuran bulanan dari anggota</li>
          <li>Lacak pembagian dan pembayaran</li>
          <li>Lihat laporan dan statistik</li>
        </ol>
      </div>
    </div>
  );
};

export default HomePage;
